import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface InputModel {
  titulo: string;
  iconoTitulo: string;
  subtitulo: string;
  botonDescarga: boolean;
  nombreDescarga: string;
  tipo: 'orden' | 'licitacion';
  link: LinkModel;
  secciones: SeccionModel[];
}

export interface LinkModel {
  url: string;
  texto: string;
  icono: string;
}

export interface SeccionModel {
  titulo: string;
  elementos?: ElementoModel[];
  lista?: ListaModel;
}

export interface ElementoModel {
  titulo: string;
  iconoTitulo: string;
  value: any;
  tipo: 'texto' | 'numero-entero' | 'numero-entero-pesos' | 'fecha' | 'rut' | 'estado';
}

export interface ListaModel {
  elementosLista: elementLista[];
  totalLista?: number | string;
}

export interface elementLista {
  producto: string;
  cantidad: number | string;
  precioUnitario: number | string;
  total: number | string;
}

@Component({
  selector: 'app-mat-mercado-publico-modal',
  templateUrl: './mat-mercado-publico-modal.component.html',
  styleUrls: ['./mat-mercado-publico-modal.component.scss']
})
export class MatMercadoPublicoModalComponent implements AfterViewInit {
  public objectKeys = Object.keys;
  public inputModel: InputModel | any = null;
  public today: string = '';

  
  constructor(public dialogRef: MatDialogRef<MatMercadoPublicoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputModel
    ) {
      this.setToday();
      this.inputModel = data;
  }

  ngAfterViewInit(): void {
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

  goToUrl(url: any): void {
    if(!url) return;
    window.open(url, '_blank');
  }

  isMaterialIcon(iconCode: string): boolean {
    if(!iconCode) return false;
    if(!iconCode.includes("fa fa-")) {
      return true;
    } else {
      return false;
    }
  }
  
  close() {
    this.dialogRef.close(false);
  }

}
